<template>
  <v-select
    :loading="loading"
    :value="value"
    @input="input => $emit('input', input)"
    :items="domains"
    item-text="name"
    item-value="id"
    label="Domínio padrão"
    placeholder="Selecione"
    clearable
    outlined
    hide-details
  ></v-select>
</template>

<script>
import DomainService from '@/services/DomainService'

export default {
  props: ['value', 'user_id'],
  data () {
    return {
      loading: false,
      domains: []
    }
  },
  mounted () {
    this.index()
  },
  methods: {
    async index () {
      this.loading = true
      this.domains = await DomainService.index({ user_id: this.user_id })
      this.loading = false
    }
  }
}
</script>

<style lang="sass" scoped>

</style>